import React from "react";
import { toast } from "react-toastify";
const IconAlertTriangle = React.lazy(() => import("../icons/IconAlertTriangle" /* webpackChunkName: "iconAlertTriangle" */));

export const ToastError = ({ message }: { message: string }) => {
  return (
    <div className="d-flex">
      <div className="mr-2">
        <IconAlertTriangle />
      </div>
      <div>
        <h4 className="alert-title">Error</h4>
        <div className="text-muted">{ message }</div>
      </div>
    </div>
  );
};

export const ToastErrorPlus = (message: string) => {
  return toast.error((
    <div className="d-flex">
      <div className="mr-2">
        <IconAlertTriangle />
      </div>
      <div>
        <h4 className="alert-title">Error</h4>
        <div>{ message }</div>
      </div>
    </div>
  ), { position: toast.POSITION.TOP_RIGHT });
}

const Toast = {
  Error: ToastError
};

export default Toast;